<template>

    <modal :showModal="showModal" :hideModal="closeModal">

        <h5 slot="header">
            Téléchargement du CSV
        </h5>

        <div slot="body">

            <span>
                {{ stateMessage }}
            </span>

            <br/>

            <span v-if="!!jobCount">
                Place dans la liste des traitements : {{ jobCount }}
            </span>

        </div>

        <div slot="footer">
            <button class="btn btn-danger" @click="closeModal">
                Fermer
            </button>
        </div>

    </modal>

</template>

<script>

import axios from "axios";
import Modal from './Modal';
import moment from "moment";

export default {
    name: 'CsvDownloadModal',
    components: {Modal},
    props: {
        showModal: {
            type: Boolean,
            required: true
        },
        downloadUrl: {
            type: String,
            required: true
        },
        fileNamePrefix: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            generationInfos: null,
            generationIsComplete: false,
            intervalId: null,
            stateMessage: "Demande de la génération du CSV...",
            jobCount: null
        }
    },
    watch: {
        showModal(value) {
            if (value === true) {
                this.requestFileGeneration();
            }
        },
        generationIsComplete(value) {
            if (value === true) {
                clearInterval(this.intervalId);
                this.downloadFile(this.generationInfos.fileName);
            }
        }
    },
    methods: {
        requestFileGeneration() {
            axios.get(this.downloadUrl).then((result) => {
                this.stateMessage = "En attente de la génération du CSV...";
                this.generationInfos = result.data;
                this.monitorGenerationState(this.generationInfos.supervisionId);
            });
        },
        monitorGenerationState(supervisionId) {
            const self = this;
            this.intervalId = setInterval(function () {
                self.requestGenerationState(supervisionId);
                self.requestJobQuantity();
            }, 5000);
        },
        requestGenerationState(supervisionId) {
            axios.get("api/supervisions/" + supervisionId).then((result) => {
                this.generationIsComplete = result.data.service_state !== "IN PROGRESS";
            });
        },
        requestJobQuantity() {
            axios.get("api/jobs/count").then((result) => {
                this.jobCount = result.data.job_count;

            });
        },
        downloadFile(fileName) {
            this.stateMessage = "Téléchargement du CSV...";
            axios({
                url: "/download/csv/" + fileName,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.fileNamePrefix + moment().format("YYYYMMDD-HHmmss") + '.csv');
                document.body.appendChild(link);
                link.click();
                this.jobCount = null;
                this.generationIsComplete = false;
                this.closeModal();
            });
        },
        closeModal() {
            this.$emit("closeModal");
        }
    }
}

</script>



// WEBPACK FOOTER //
// resources/js/components/layout/CsvDownloadModal.vue